import { InstrumentEntity, InstrumentTypeEntity } from "../../domain/entities/InstrumentEntity";
import {
    useGetInstrument,
    useGetInstrumentTypes,
} from "./useInstrumentQueries";

import { useMemo } from "react";
import { enrichInstrument } from "../../infrastructure/InstrumentlMapper";

type OptionItem = { id: number | string; name: string };

const mapToOptions = (data: OptionItem[] = []) => {

    return data.map(({ id, name }) => ({
        label: name,
        value: id.toString(),
    }));
}

export const useInstrumentConfigData = () => {
    const { data: instrumentsData, isLoading: instrumentsIsLoading, refetch: instrumentsRefetch } = useGetInstrument();
    const { data: instrumentTypesData, isLoading: instrumentTypesIsLoading } = useGetInstrumentTypes();

    const instrumentTypeOptions = useMemo(
        () => mapToOptions(instrumentTypesData?.data),
        [instrumentTypesData]
    );

    const instruments: InstrumentEntity[] = [];
    if (instrumentsData?.data) {
        instrumentsData.data.map((item) => {
            const {
                id,
                mnemonic,
                instrumentType,
                isin,
                currency,
                interestRate,
                frequency,
                issuanceDate,
                maturityDate,
                issuerName,
                rating,
                validation,
                createdAt,
                updatedAt,
            } = item;

            const enrichedItem = enrichInstrument(
                {
                    mnemonic,
                    instrumentType,
                    isin,
                    currency,
                    interestRate,
                    frequency,
                    issuanceDate,
                    maturityDate,
                    issuerName,
                    rating,
                    validation,
                },
                id,
                new Date(createdAt),
                updatedAt ? new Date(updatedAt) : null,
                {
                    instrumentTypes: instrumentTypesData?.data as unknown as InstrumentTypeEntity[],
                }
            );

            if (enrichedItem) {
                instruments.push(enrichedItem);
            }
        });
    }

    const isLoading =
        instrumentsIsLoading ||
        instrumentTypesIsLoading;

    return {
        instruments,
        isLoading,
        instrumentTypeOptions,
        instrumentsRefetch,
    };
}
